import { FormControl, Button } from '@mui/material';
import { useField } from 'formik';
import QuestionLayout from './QuestionLayout';
import { useAppSelector } from 'src/utils/hooks';
interface Props {
  question: Question;
  downloadDocument: () => void;
}

export default function DownloadButton({ question, downloadDocument }: Props) {
  const [field, meta, helpers] = useField(question.key);
  const { isColorBlindMode } = useAppSelector((state) => state.config);
  return (
    <QuestionLayout question={question} meta={meta}>
      <FormControl error={meta.touched && Boolean(meta.error)}>
        <Button
          key={question.key}
          variant="contained"
          color="primary"
          disabled={
            field.value === 'true' || question.answer.value === 'true'
              ? true
              : false
          }
          onClick={() => {
            downloadDocument();
            helpers.setValue('true');
          }}
          sx={
            isColorBlindMode
              ? {
                  backgroundColor: 'accessibility.button.main',
                  color: 'accessibility.button.contrastText',
                  textDecoration: 'underline',
                  textUnderlineOffset: '2.5px',
                  '&:hover': {
                    backgroundColor: '#222',
                    color: 'accessibility.button.contrastText',
                    textDecoration: 'underline',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: 'text.disabled',
                    color: 'accessibility.button.contrastText',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2.5px',
                  },
                }
              : {}
          }
        >
          Dokument herunterladen
        </Button>
      </FormControl>
    </QuestionLayout>
  );
}
